import { render, staticRenderFns } from "./KnFilteredSyllabusTable.vue?vue&type=template&id=f650df16"
import script from "./KnFilteredSyllabusTable.js?vue&type=script&lang=js&external"
export * from "./KnFilteredSyllabusTable.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports